import script from "./RichText.vue?vue&type=script&setup=true&lang=js"
export * from "./RichText.vue?vue&type=script&setup=true&lang=js"

import "./RichText.vue?vue&type=style&index=0&id=0ef61998&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef61998"]])

export default __exports__